module.exports = __webpack_public_path__ + "img/training-centre-balloons.dfb775f5.png";